import { render } from "./Projects.vue?vue&type=template&id=02ca7382"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=02ca7382&lang=css"

import exportComponent from "/home/davlu/Documentos/Repositorios/ProyectosWeb/luisdtorresp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__